type Props = {
  variant: "filled" | "light" | "danger";
  size: "xs" | "sm" | "lg";
  disabled?: boolean;
};

const DEFAULT_PROPS: Props = { variant: "filled", size: "sm", disabled: false };

export function getClass(props: Props = DEFAULT_PROPS): string {
  let sizeClass: string;
  switch (props.size) {
    case "xs":
      sizeClass = "px-1 py-0.5 text-sm ";
      break;
    case "sm":
      sizeClass = "px-2 py-1 ";
      break;
    case "lg":
      sizeClass = "px-4 py-2 ";
      break;
  }

  return (
    "border rounded-full text-center " +
    sizeClass +
    (props.disabled === true ? "cursor-not-allowed " : "cursor-pointer ") +
    getColors(props.variant, props.disabled)
  );
}

function getColors(
  variant: Props["variant"],
  disabled: Props["disabled"],
): string {
  if (disabled) {
    return "bg-gray border-gray text-white";
  }

  switch (variant) {
    case "filled":
      return "bg-blue hover:bg-darkBlue text-white border-blue";
    case "light":
      return "bg-white hover:text-darkBlue text-blue border-blue hover:border-darkBlue";
    case "danger":
      return "bg-red hover:bg-darkRed text-white border-red";
  }
}
